module.exports = __webpack_public_path__ + "img/144.2f09bc22.jpg";